<template>
    <div class="d-flex justify-center pa-6">
        <v-card max-width="900" width="100%" elevation="3">
            <v-card-title class="text-h5"> Signature Request </v-card-title>

            <v-divider />

            <v-card-text>
                <!-- SIGNED STATE -->
                <div v-if="signed" class="text-center py-8">
                    <v-icon size="48" color="success" icon="mdi:mdi-check-circle" />
                    <div class="text-h6 mt-2">
                        Signature captured. Thank you.
                    </div>
                </div>

                <!-- SIGNATURE STATE -->
                <div v-else class="d-flex flex-column align-center">
                    <div class="text-h6 mb-2">
                        {{ name }}
                    </div>

                    <div class="text-subtitle-1 mb-4">Please sign below:</div>

                    <div class="signature-container">
                        <VueSignaturePad
                            ref="signaturePad"
                            class="signature-pad"
                        />
                    </div>

                    <!-- BUTTONS -->
                    <div
                        class="d-flex justify-space-between mt-6 w-100 buttons-container"
                    >
                        <v-btn
                            color="grey-darken-1"
                            variant="outlined"
                            size="large"
                            class="flex-grow-1 mr-2"
                            :disabled="loading"
                            @click="clearSignature"
                        >
                            Clear
                        </v-btn>

                        <v-btn
                            color="primary"
                            size="large"
                            class="flex-grow-1 ml-2"
                            :loading="loading"
                            :disabled="loading || $refs.signaturePad?.isEmpty?.()"
                            @click="saveSignature"
                        >
                            <v-icon start icon="mdi:mdi-content-save" />
                            Submit Signature
                        </v-btn>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import { defineAsyncComponent } from "vue";

const GuestLayout = defineAsyncComponent(() =>
    import("../../Layouts/GuestLayout.vue")
);

export default {
    components: { GuestLayout },
    layout: [GuestLayout],
    props: {
        token: String,
        signatureId: Number,
        name: String,
        signatureData: Array,
        signed: Boolean,
    },

    data() {
        return {
            loading: false,
        };
    },

    methods: {
        clearSignature() {
            this.$refs.signaturePad.clearSignature();
        },
        async saveSignature() {
            try {
                this.loading = true;

                const signaturePad = this.$refs.signaturePad;

                // Prevent empty signatures
                if (signaturePad.isEmpty()) {
                    alert("Please provide a signature before submitting.");
                    this.loading = false;
                    return;
                }

                const signature = signaturePad.toData();

                await axios.post("/api/training/signature/save", {
                    token: this.token,
                    signature: signature,
                });

                // reload page to show "Signature captured" message
                this.$inertia.reload();
            } catch (error) {
                let message = "Unable to save signature. Please try again.";

                if (error.response && error.response.data?.message) {
                    message = error.response.data.message;
                }

                alert(message);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.signature-container {
    width: 100%;
    max-width: 800px;
    overflow-x: auto;
}

.signature-pad {
    width: 800px;
    height: 300px;
    border: 1px solid #ccc;
    background-color: white;
    border-radius: 4px;
}

.buttons-container {
    max-width: 800px;
}
</style>
